export * from './order-detail.component';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/orders/order-detail/index.ts